import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function O2LayoutColumn(props) {
  var className = props.className,
      pos = props.pos,
      func = props.func,
      attributes = _objectWithoutPropertiesLoose(props, ["className", "pos", "func"]);

  var classes = classNames(className, 'o2-layout__' + pos + '-' + func);
  return /*#__PURE__*/React.createElement("div", _extends({}, attributes, {
    className: classes
  }));
}

O2LayoutColumn.propTypes = {
  className: PropTypes.string,
  pos: PropTypes.oneOf(['left', 'right', 'center', 'narrow']).isRequired,
  func: PropTypes.oneOf(['main', 'side', 'preamble']).isRequired
};
O2LayoutColumn.defaultProps = {
  pos: 'center',
  func: 'main'
};
export default O2LayoutColumn;